module.exports = __webpack_public_path__ + "img/content-1.21a92cc0.png";